enum Mutation {
  SET_AGGREGATIONS = 'setAggregations'
}

export default Mutation;
